uniform vec2 resolution;
uniform float devicePixelRatio;
uniform float time;
varying vec2 vUv;

#pragma glslify: oklabToLinearSRGB = require(./../../shaders/oklab-to-linear-srgb)
#pragma glslify: oklchToOklab = require(./../../shaders/oklch-to-oklab)

void main() {
    vec2 st = gl_FragCoord.xy / resolution.xy / devicePixelRatio;


    // MDN says a and b are from -0.4 to -0.4
    // https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/oklab 
    // float lightness = 0.5 + 0.5 * sin(time * 0.001);
    // vec3 oklabA = vec3(lightness, -0.4, -0.4 + (vUv.y * 0.8));
    // vec3 oklabB = vec3(lightness, 0.4, -0.4 + (vUv.y * 0.8));
    // vec3 rgb = oklabToLinearSRGB(mix(oklabA, oklabB, vUv.x));

    //Note chroma with 0.5 is the only white
    // float lightness = 0.5 + 0.5 * sin(time * 0.001);
    // vec3 oklabA = oklchToOklab(lightness, 0.2, 0.0);
    // vec3 oklabB = oklchToOklab(lightness, 0.2, 2.0 * 3.14159265358979323);
    // vec3 rgb = oklabToLinearSRGB(mix(oklabA, oklabB, vUv.x));

    // https://evilmartians.com/chronicles/oklch-in-css-why-quit-rgb-hsl
    // https://oklch.com/#63.27,0.1369,126.57,100
    // https://svgees.us/Color/ok-clip-lch-explorer.html
    float lightness = (0.5 + 0.5 * cos(time * 0.001)) * 1.0; //0.74; 
    vec3 oklchA = vec3(lightness, 0.1369 * vUv.y, 0.0);
    vec3 oklchB = vec3(lightness, 0.34 * vUv.y, 2.0 * 3.1415926535897931);
    vec3 rgb = oklabToLinearSRGB(oklchToOklab(mix(oklchA, oklchB, vUv.x)));

    // Some articles mention 0.34 for chroma
    // vec3 rgb = oklabToLinearSRGB(oklchToOklab(1.0, 0.34, (2.0 * 3.14159265358979323) * vUv.x));

    rgb = clamp(rgb, vec3(0.0), vec3(1.0));
    
    gl_FragColor = vec4(rgb, 1.0);
}